module.exports = __webpack_public_path__ + "img/hotel-5.8c1f8462.jpeg";